"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTravellingHoursError = exports.checkGpsWorkHoursError = exports.summaryTravellingErrors = exports.summaryWorkErrors = exports.SummaryRule = exports.worklogsToSummary = exports.getDayGpsSummaryHoursFomRules = exports.reduceWorklogs = exports.isWorkLogSummaryEmpty = exports.newWorkLogSummary = void 0;
var index_1 = require("./index");
var _ = require("lodash");
var constants_1 = require("../constants");
/** ------------------------- SUMMARY HELPERS ------------------------ */
var newWorkLogSummary = function () {
    return {
        date_worked: '',
        working: { hours: 0, gpsHour: 0, approvedHours: 0 },
        travelling: { hours: 0, gpsHour: 0, approvedHours: 0 },
        special: { hours: 0, gpsHour: 0, approvedHours: 0 },
    };
};
exports.newWorkLogSummary = newWorkLogSummary;
var isWorkLogSummaryEmpty = function (summary) {
    return !summary.special.approvedHours
        && !summary.travelling.approvedHours
        && !summary.working.approvedHours;
};
exports.isWorkLogSummaryEmpty = isWorkLogSummaryEmpty;
var reduceWorklogs = function (weekHours) {
    var week = _.reduce(weekHours.worklogs, function (weekSummary, daySummary) {
        weekSummary.special = addHours(weekSummary.special, daySummary.special);
        weekSummary.travelling = addHours(weekSummary.travelling, daySummary.travelling);
        weekSummary.working = addHours(weekSummary.working, daySummary.working);
        return weekSummary;
    }, (0, exports.newWorkLogSummary)());
    week.date_worked = weekHours.worklogs[0].date_worked
        + ' - ' + weekHours.worklogs[weekHours.worklogs.length - 1].date_worked;
    return week;
};
exports.reduceWorklogs = reduceWorklogs;
// We asumme here we pass the rules for the DAY
var getDayGpsSummaryHoursFomRules = function (weekHours, weekDayIndex, hoursType) {
    // Getting the data
    return _.cloneDeep(weekHours.worklogs[weekDayIndex]);
};
exports.getDayGpsSummaryHoursFomRules = getDayGpsSummaryHoursFomRules;
var worklogsToSummary = function (worklogs) {
    return _.reduce(worklogs, function (summary, worklog) {
        var rule = (0, index_1.getWorkLogRule)(worklog);
        if (!rule) {
            return summary;
        }
        var ruleHash = (0, index_1.hashRule)(rule);
        // Working hours type work
        if (rule.timeType === index_1.ValidationType.PROJECT) {
            summary.working.hours += worklog.hours;
            summary.working.approvedHours += worklog.approvedHours || 0;
            summary.working.gpsHour += summary.working.gpsHour === 0 ? worklog.gpsHours : 0;
        }
        // Working hours type travel
        if (rule.timeType === index_1.ValidationType.TRAVELLING) {
            summary.travelling.hours += worklog.hours;
            summary.travelling.approvedHours += worklog.approvedHours || 0;
            summary.travelling.gpsHour += worklog.gpsHours;
            summary.travelling.gpsHour += summary.travelling.gpsHour === 0 ? worklog.gpsHours : 0;
        }
        // Special hours
        if (rule.timeType === index_1.ValidationType.NOT_WORKED) {
            summary.special.hours += worklog.hours;
            summary.special.approvedHours += worklog.approvedHours || 0;
        }
        return summary;
    }, (0, exports.newWorkLogSummary)());
};
exports.worklogsToSummary = worklogsToSummary;
// Add two hours objects
var addHours = function (a, b) {
    a.approvedHours += b.approvedHours;
    a.hours += b.hours;
    a.gpsHour += b.gpsHour;
    return a;
};
/** ------------------------- SUMMARY VALIDATION ------------------------ */
var SummaryRule;
(function (SummaryRule) {
    SummaryRule["LUNCH_RULE"] = "De lunchtijd kan niet als werktijd worden geregistreerd";
    SummaryRule["MIN_WORK_TIME"] = "Minimaal aantal werkuren niet bereikt.";
    SummaryRule["WORK_TIME"] = "De geregistreerde werktijd overschrijdt de gps-tijd.";
    SummaryRule["TRAVEL_TIME"] = "Reistijd ingelogd overschrijdt gps-tijd.";
})(SummaryRule = exports.SummaryRule || (exports.SummaryRule = {}));
var summaryWorkErrors = function (summary) {
    var errorList = [];
    // If hours are 0, we don-t compared approved hours, as it is choice of the approver
    if (summary.working.hours === 0) {
        return [];
    }
    if ((0, exports.checkGpsWorkHoursError)(summary)) {
        errorList.push(SummaryRule.WORK_TIME);
    }
    else if (checkLunchTimeError(summary)) {
        errorList.push(SummaryRule.LUNCH_RULE);
    }
    // Keep adding rules related to the summary
    // ...
    return errorList;
};
exports.summaryWorkErrors = summaryWorkErrors;
var summaryTravellingErrors = function (summary) {
    var errorList = [];
    // If hours are 0, we don-t compared approved hours, as it is choice of the approver
    if (summary.working.hours === 0) {
        return [];
    }
    if ((0, exports.checkTravellingHoursError)(summary)) {
        errorList.push(SummaryRule.WORK_TIME);
    }
    // Keep adding rules related to the summary
    // ...
    return errorList;
};
exports.summaryTravellingErrors = summaryTravellingErrors;
var checkGpsWorkHoursError = function (summary) {
    return summary.working.gpsHour + constants_1.VALID_TIME_RANGE < summary.working.approvedHours;
};
exports.checkGpsWorkHoursError = checkGpsWorkHoursError;
var checkTravellingHoursError = function (summary) {
    return summary.travelling.gpsHour + constants_1.VALID_TIME_RANGE < summary.travelling.approvedHours;
};
exports.checkTravellingHoursError = checkTravellingHoursError;
var checkLunchTimeError = function (summary) {
    return summary.working.approvedHours > summary.working.gpsHour - constants_1.LUNCH_TIME + constants_1.VALID_TIME_RANGE;
};
